import { render, staticRenderFns } from "./AccountTypeSubheader.vue?vue&type=template&id=79a080ee&scoped=true"
import script from "./AccountTypeSubheader.vue?vue&type=script&lang=ts"
export * from "./AccountTypeSubheader.vue?vue&type=script&lang=ts"
import style0 from "./AccountTypeSubheader.vue?vue&type=style&index=0&id=79a080ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a080ee",
  null
  
)

export default component.exports